import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { debounce } from "lodash-es";
import { ref, watchEffect, onMounted } from "vue";
import { useI18n } from "vue-i18n";

import { baseInput, baseTextarea } from "@/common/components";

import { BreakPayloadType } from "@/common/types/breaks";


export default /*@__PURE__*/_defineComponent({
  __name: 'breaks',
  props: {
    data: {},
    width: { default: "100%" },
    patch: { type: Boolean, default: false }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const payload = ref<BreakPayloadType>({
  motive: "",
  description: null,
});

function update(key: keyof typeof payload.value) {
  if (props.patch) {
    emit("update-data", { [key]: payload.value[key] });
    return;
  }

  emit("update-data", {
    ...payload.value,
    [key]: payload.value[key],
  });
}

const debounceForm = debounce(update, 300);

watchEffect(() => {
  if (props.data) {
    const { motive, description } = props.data;
    payload.value = { motive, description };
  }
});

onMounted(() => {
  emit("update-data", payload.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      _createVNode(_unref(baseInput), {
        modelValue: payload.value.motive,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.motive) = $event)),
        value: payload.value.motive,
        placeholder: _unref(t)('analysis.placeholder.motive'),
        onInput: _cache[1] || (_cache[1] = ($event: any) => (_unref(debounceForm)('motive')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("analysis.labels.motive")) + " ", 1),
          _cache[4] || (_cache[4] = _createElementVNode("sup", null, "*", -1))
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.description,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payload.value.description) = $event)),
        value: payload.value.description,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_unref(debounceForm)('description')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.description")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})